import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Pagination,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import { Link, useNavigate } from "react-router-dom";
import SkeletonWrapper from "../../../components/Skeleton/SkeletonWrapper";
import { EncryptDecryptService } from "../../../services/common/EncryptionService";
import { PreferencesContext } from "../../../PreferenceContext";
import { AlertType } from "../../../services/models/AlertType";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DeleteOutReachLocation } from "../../../services/TeamMemberService";
// import SkeletonWrapper from "./SkeletonWrapper"; // your existing skeleton wrapper
// import edService from "../services/edService"; // encryption service

interface HospitalItem {
  hospitalId: number;
  hospitalName: string;
  contactPerson: string;
  address1?: string;
  address2?: string;
  city?: string;
  countryRegionName?: string;
  email?: string;
  primaryMobileNumber?: string;
}

interface OutReachOPDListProps {
  hospitalData: HospitalItem[];
  showSkeleton?: boolean;
  skeletonRowCount?: number;
  value: string;
  setValue: (v: string) => void;
  searchValue: (v: string) => void;
  page: number;
  rowsPerPage: number;
  Curr_page: number;
  counDataHospital: number;
  pageStartIndexHospital: number;
  pageEndIndexHospital: number;
  totalCountHospital: number;
  order: any;
  orderBy: any;
  //   handleCheckSelectAll: () => void;
  handleChangePageNew: (_: any, page: number) => void;
  curDoctorId: number;
  getOutReachLocationList: () => Promise<void>;
  maxOutreachOpdLocation: number;
}

const OutReachOPDList: React.FC<OutReachOPDListProps> = ({
  hospitalData,
  showSkeleton = false,
  skeletonRowCount = 5,
  value,
  setValue,
  searchValue,
  page,
  rowsPerPage,
  Curr_page,
  counDataHospital,
  pageStartIndexHospital,
  pageEndIndexHospital,
  totalCountHospital,
  order,
  orderBy,
  //   handleCheckSelectAll,
  handleChangePageNew,
  curDoctorId,
  getOutReachLocationList,
  maxOutreachOpdLocation,
}) => {
  const navigate = useNavigate();
  const edService = new EncryptDecryptService();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const stableSort = (array: any[], comparator: any) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };
  const [anchorEl, setAnchorEl3] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const [OutReachLocationId, setOutReachLocationId] = useState(0);
  const [openDeleteDilog, setOpenDeleteDilog] = React.useState(false);
  const [openAddOutReachModal, setOpenAddOutReachModal] = useState(false);
  const handleCloseAddOutReachModal = () => {
    setOpenAddOutReachModal(false);
  };
  const getComparator = (order: any, orderBy: any) => {
    return order === "desc"
      ? (a: any, b: any) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a: any, b: any) => (a[orderBy] < b[orderBy] ? -1 : 1);
  };

  // HANDLE POPUP FOR EDIT AND DELETE
  const handleOpenMore = (
    event: React.MouseEvent<HTMLButtonElement>,
    teamMemberLocationMappingId: any,
  ) => {
    setAnchorEl3(event.currentTarget);
    setOutReachLocationId(teamMemberLocationMappingId);
  };

  // CLOSE POPUP
  const handleCloseMore = () => {
    setAnchorEl3(null);
  };

  // HANDLE DELETE WARNING POPUP
  const handleDeleteDilog = (value: any) => {
    setOpenDeleteDilog(value);
  };

  const upgradeSubscription = () => {
    navigate("/help");
  };
  // HANDLE UPDATE
  const handleUpdate = (teamMemberLocationMappingId: any, doctorId: any) => {
    let encryptDoctorId: any = edService.encrypt(teamMemberLocationMappingId);
    if (hospitalData.length >= maxOutreachOpdLocation) {
      if (userContext.loginDetail.userRole !== "superadmin") {
        setOpenAddOutReachModal(true);
      } else {
        navigate(
          {
            pathname: "../out-reach-opd",
            // search: `?q=${encodeURIComponent(encryptDoctorId)}`,
          },
          {
            state: {
              title: " Edit",
              button: "Update",
              teamMemberLocationMappingId: teamMemberLocationMappingId,
              doctorId: doctorId,
              maxOutreachOpdLocation: maxOutreachOpdLocation,
            },
          },
        );
      }
    } else {
      navigate(
        {
          pathname: "../out-reach-opd",
          // search: `?q=${encodeURIComponent(encryptDoctorId)}`,
        },
        {
          state: {
            title: " Edit",
            button: "Update",
            teamMemberLocationMappingId: teamMemberLocationMappingId,
            doctorId: doctorId,
            maxOutreachOpdLocation: maxOutreachOpdLocation,
          },
        },
      );
    }
  };

  // HANDLE DELETE
  async function deleteRow(teamMemberLocationMappingId: any) {
    try {
      setAnchorEl3(null);
      handleDeleteDilog(false);
      let DeleteData = {
        teamMemberLocationMappingIds: teamMemberLocationMappingId?.toString(),
        consumerId: userContext?.consumerId?.toString(),
        branchId: userContext?.branchId?.toString(),
        organizationId: userContext?.organizationId?.toString(),
        isDeleted: true,
        dataManagedBy: userContext?.loginDetail?.userId,
      };
      const result: any = await DeleteOutReachLocation(DeleteData);
      if (result) {
        await getOutReachLocationList();
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Success,
        });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result.message,
          alertType: AlertType.Error,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  return (
    <>
      <Grid container gap={2}>
        <Grid container className="list-container">
          <Grid item xs={8} sm={8} md={8} lg={10}></Grid>

          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            lg={2}
            className="search-bar pdf-icon"
          >
            <Box className="page-header-icon">
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  handleUpdate(0, curDoctorId);
                }}
                size="medium"
                startIcon={<AddIcon />}
              >
                Add
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} mt={2}>
            <TableContainer>
              <Table>
                <TableHead className="table-header-color">
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", width: "30%" }}>
                      Hospital
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: "30%",
                        display: { xs: "none", sm: "table-cell" },
                      }}
                    >
                      Address
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: "30%",
                        display: { xs: "none", sm: "table-cell" },
                      }}
                    >
                      Contact
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", width: "10%" }}
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {showSkeleton
                    ? Array(skeletonRowCount)
                        .fill(0)
                        .map((_, idx) => (
                          <TableRow key={`skeleton-${idx}`}>
                            <TableCell colSpan={8}>
                              <SkeletonWrapper
                                isLoading={showSkeleton}
                                className="skeleton-input"
                                children={undefined}
                              />
                            </TableCell>
                          </TableRow>
                        ))
                    : stableSort(hospitalData, getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((item) => (
                          <TableRow key={item.locationId}>
                            <TableCell>
                              <span
                                className="text-link"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleUpdate(
                                    item.teamMemberLocationMappingId,
                                    curDoctorId,
                                  )
                                }
                              >
                                {item.hospitalName}
                              </span>
                              <br />
                              <span>{item.contactPerson}</span>
                            </TableCell>

                            <TableCell
                              sx={{ display: { xs: "none", sm: "table-cell" } }}
                            >
                              {[
                                item.address1,
                                item.address2,
                                item.city,
                                item.countryRegionName,
                              ]
                                .filter(Boolean)
                                .join(", ")}
                            </TableCell>
                            <TableCell
                              sx={{ display: { xs: "none", sm: "table-cell" } }}
                            >
                              {item.email}
                              <br />
                              {item.primaryMobileNumber}
                            </TableCell>
                            <TableCell align="right">
                              <Tooltip title="More" placement="top">
                                <IconButton
                                  onClick={(e) =>
                                    handleOpenMore(
                                      e,
                                      item.teamMemberLocationMappingId,
                                    )
                                  }
                                >
                                  <MoreVertRoundedIcon />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                  {!hospitalData.length && !showSkeleton && (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No record(s) found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {hospitalData.length > 0 && (
            <Grid item xs={12} paddingTop={1}>
              <Box className="pagination">
                <Box className="pagination-label">
                  <SkeletonWrapper isLoading={showSkeleton}>
                    {pageStartIndexHospital} - {pageEndIndexHospital} of{" "}
                    {totalCountHospital}
                  </SkeletonWrapper>
                </Box>
                <Box className="pagination-stack">
                  <SkeletonWrapper isLoading={showSkeleton}>
                    <Stack component="div">
                      <Pagination
                        color="primary"
                        count={counDataHospital}
                        page={Curr_page}
                        onChange={handleChangePageNew}
                      />
                    </Stack>
                  </SkeletonWrapper>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Popover
        elevation={1}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseMore}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => handleUpdate(OutReachLocationId, curDoctorId)}
            >
              <ListItemText primary="Edit" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              className="delete-container"
              onClick={() => {
                handleDeleteDilog(true);
              }}
            >
              Delete
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
      <Dialog
        open={openDeleteDilog}
        onClose={() => {
          handleDeleteDilog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this Hospital?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteRow(OutReachLocationId);
            }}
            className="button-delete"
          >
            Yes
          </Button>
          <Button
            onClick={(e) => {
              handleDeleteDilog(false);
            }}
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddOutReachModal}
        maxWidth="sm"
        sx={{ padding: "16px !important", top: 64, minWidth: "320px" }}
      >
        <DialogContent sx={{ width: "100% !important" }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <InfoOutlinedIcon color="primary" />
            <Box>
              <Typography className="font-size-16 bold-600 primary-color">
                {" "}
                Requires an upgrade
              </Typography>
              <Typography sx={{ mb: 2 }}>
                Please upgrade your subscription to add-on another OutReach OPD.
              </Typography>
            </Box>
          </Box>

          <Box display={"flex"} justifyContent={"end"} gap={2}>
            <Button variant="contained" onClick={() => upgradeSubscription()}>
              Upgrade
            </Button>
            <Button variant="text" onClick={handleCloseAddOutReachModal}>
              Cancel
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OutReachOPDList;
